import { Datagrid, FunctionField, List, TextField, usePermissions } from "react-admin";
import { hasPermission } from "@/utils/permission-utils";
import { useRouteId } from "@/utils/route-utility";

const typeLabels: Record<string, string> = {
  NIYAAZ_FORM: "Form",
  NIYAAZ_RECEIPT: "Receipt",
};

export const EventSequenceList = () => {
  const { permissions } = usePermissions();
  const canEdit = hasPermission(permissions, "event.edit");
  const eventId = useRouteId();

  return (
    <List
      resource="eventSequences"
      filter={eventId ? { eventId } : undefined}
      sort={{ field: "type", order: "ASC" }}
      title="Event sequences"
    >
      <Datagrid rowClick={canEdit ? "edit" : false}>
        <FunctionField
          label="Type"
          render={(record: { type?: string; venueCode?: string | null }) => {
            const base = typeLabels[record.type ?? ""] ?? record.type;
            if (record.type === "NIYAAZ_FORM" && record.venueCode) {
              return `${base} (${record.venueCode})`;
            }
            return base;
          }}
        />
        <TextField source="prefix" label="Prefix" />
        <TextField source="currentValue" label="Current value" />
        <TextField source="eventId" label="Event ID" />
      </Datagrid>
    </List>
  );
};
